import React, { useRef } from "react";
import { useCalendarCell } from "react-aria";
import { isSameMonth } from "@internationalized/date";
import { Button } from "./Button";
import styled, { css } from "styled-components";

export function CalendarCell({ state, date, currentMonth }) {
  const ref = useRef();
  const {
    cellProps,
    buttonProps,
    isSelected,
    isDisabled,
    isUnavailable,
    formattedDate,
  } = useCalendarCell({ date }, state, ref);

  const isOutsideMonth = !isSameMonth(currentMonth, date);

  return (
    <Box {...cellProps}>
      <CellButton
        {...buttonProps}
        ref={ref}
        isOutsideMonth={isOutsideMonth}
        isDisabled={isDisabled}
        isSelected={isSelected}
        isUnavailable={isUnavailable}
      >
        {formattedDate}
      </CellButton>
    </Box>
  );
}

const Box = styled.td`
  text-align: center;
`;

const CellButton = styled(Button)`
  display: inline-flex;
  font-size: 0.875rem;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
  line-height: 1.2;
  border-radius: 50%;
  font-weight: 1.063rem;
  transition-property: background-color;
  transition-duration: 200ms;
  height: 2.25rem;
  width: 2.25rem;
  color: #444444;
  &:hover {
    background-color: #ddd;
  }

  ${({ isOutsideMonth }) =>
    isOutsideMonth &&
    css`
      display: none;
    `}

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: #84a4fa;
      -webkit-text-fill-color: white;
    `}

  ${({ isDisabled, isUnavailable }) =>
    (isDisabled || isUnavailable) &&
    css`
      &:hover {
        background-color: transparent;
      }
      cursor: not-allowed;
      opacity: 0.3;
    `}
`;
